import React from 'react';

const AimAndScope = () => {
    return (
        <div className="about-ed-wrapper-impact">
            <h2 className="about-ed-heading-impact">Aim & Scope</h2>

            {/* Aim Section */}
            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Aim</div>
                <div className="about-ed-content-impact">
                    <p>
                        <strong>IMPACT - INTERNATIONAL MULTIDISCIPLINARY PHARMACEUTICAL AND CLINICAL TRENDS</strong> is dedicated to the rapid publication of high-quality articles that advance the frontiers of pharmacy and medical sciences. As an esteemed, peer-reviewed journal, IMPACT serves as a dynamic platform for researchers, clinicians, and industry professionals to share innovative findings that contribute to the evolution of drug discovery, pharmaceutical advancements, and medical science.
                    </p>
                    <p>
                        Our mission is to foster scientific excellence by disseminating groundbreaking research that bridges the gap between pharmacology, pharmaceutical sciences, and medical applications. We prioritize studies that drive innovation in the development, evaluation, and optimization of therapeutics and healthcare solutions.
                    </p>
                </div>
            </div>

            {/* Scope Section */}
            <div className="about-ed-block-impact">
                <div className="about-ed-role-impact">Scope</div>
                <div className="about-ed-content-impact">
                    <p>
                        IMPACT welcomes a diverse range of contributions, including original research, systematic reviews, mini-reviews, book chapters, and clinical & preclinical investigations that explore key areas such as:
                    </p>
                    <ul>
                        <li><i className="fas fa-chevron-right"></i><strong>Pharmacology & Pharmaceutical Sciences</strong> – Advancements in drug action, pharmacokinetics, pharmacodynamics, and clinical applications.</li>
                        <li><i className="fas fa-chevron-right"></i><strong>Medicinal Chemistry & Biotechnology</strong> – Drug design, synthesis, and biotechnology-driven therapeutic innovations.</li>
                        <li><i className="fas fa-chevron-right"></i><strong>Quality Assurance (QA) & Quality Control (QC)</strong> – Ensuring efficacy, safety, and regulatory compliance in pharmaceutical development.</li>
                        <li><i className="fas fa-chevron-right"></i><strong>Pharmaceutical Analysis & Drug Development</strong> – Analytical techniques, formulation sciences, and novel drug delivery systems.</li>
                    </ul>
                    <p>
                        By providing a comprehensive repository of high-impact research, IMPACT aims to support the scientific community in shaping the future of pharmacology and medical sciences while upholding the highest standards of academic integrity and innovation.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AimAndScope;
